(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/utils.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/utils.js');
const showErrorDialog = (errorMessage) => {
  svs.components.dialog.api.close();
  svs.components.dialog.api.add(new svs.components.dialog.Confirm({
    branding: svs.components.dialog.branding.TUR,
    type: svs.components.dialog.type.ERROR,
    icon: 'exclamation-sign',
    title: 'Fel',
    message: [
      {
        type: svs.components.dialog.message.TEXT,
        text: errorMessage || 'Ett oväntat fel har inträffat.'
      }
    ],
    actions: [{
      title: 'Okej',
      callback: (e, forms, dialog) => {
        dialog.close();
      }
    }]
  }));
};

const getArticleById = (articleId, articles) => {
  return articles.find(({ ticketId }) => ticketId === articleId);
};

const orderTexts = (rows, availableTickets) => {
  const parentDiv = document.createElement('div');
  for (let i = 0; i < rows.length; i++) {
    const { articleId, count } = rows[i];
    const { ticketTitle: productName } = getArticleById(articleId, availableTickets);
    const div = document.createElement('div');
    div.innerText = `${parseInt(count, 10)} st ${productName}`;
    parentDiv.appendChild(div);
  }
  return parentDiv;
};

const showSummaryDialog = async (orderCb, order, availableTickets) => {
  const { sum, rows = [] } = order;
  const productsText = orderTexts(rows, availableTickets);
  svs.ui.dialog.api.close();
  svs.ui.dialog.api.add(new svs.components.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.SUCCESS,
    icon: 'thumbs-up',
    title: 'Vill du genomföra din beställning?',
    message: [
      {
        type: svs.ui.dialog.message.TEXT,
        text: `Du har valt att beställa lotter för ${sum} kr.`,
        align: svs.ui.dialog.message.align.CENTER
      },
      {
        type: svs.ui.dialog.message.TEXT,
        text: `${productsText.innerHTML}`,
        align: svs.ui.dialog.message.align.CENTER
      }
    ],
    actions: [{
      title: 'Avbryt',
      callback: (e, forms, dialog) => {
        dialog.close();
      }
    }, {
      title: 'Beställ lotter',
      callback: (e, forms, dialog) => {
        dialog.close();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        orderCb();
      }
    }]
  }));
};

const showSuccessDialog = (message, title, callback = () => {
}) => {
  svs.components.dialog.api.close();
  svs.components.dialog.api.add(new svs.components.dialog.Confirm({
    branding: svs.components.dialog.branding.TUR,
    type: svs.components.dialog.type.SUCCESS,
    icon: 'thumbs-up',
    title: title,
    message: [
      {
        type: svs.components.dialog.message.TEXT,
        text: message
      }
    ],
    actions: [{
      title: 'Okej',
      callback: (e, forms, dialog) => {
        dialog.close();
        callback();
      }
    }]
  }));
};

const showTermsDialog = () => {
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.ui.dialog.branding.NEUTRAL,
    title: 'Allmänna villkor för Lotter för företag',
    message: [
      {
        type: svs.ui.dialog.message.TEXT,
        text: svs.ticket_partner.data.policyBody,
        align: svs.ui.dialog.message.align.LEFT
      }
    ],
    actions: [
      {
        title: 'Okej',
        callback: (e, forms, dialog) => {
          dialog.close();
        }
      }
    ]
  }));
};

const login = async (userName, password) => {
  const options = {
    method: 'POST',
    path: '/retailer/1/sessions/webterminal',
    data: {
      userName,
      password
    }
  };
  return await svs.core.jupiter.callAsync(options);
};

const loginErrorMapper = (err) => {
  let message;
  const code = err.code;
  switch (code) {
    case 2:
      message = 'Fel lösenord eller användarnamn.';
      break;
    case 35:
      message = 'Ingen användare med denna e-postadress kunde hittas.';
      break;
    default:
      message = 'Tekniskt fel, var god försök senare.';
  }
  return message;
};

const productMapper = (productId) => {
  switch (productId) {
    case 3:
      return 'Triss Presentkod';
    case 4:
      return 'Dubbeltriss Presentkod';
    case 5:
      return 'Triss 40 kr Presentkod';
    case 6:
      return 'SkrapLotto Presentkod';
    case 7:
      return 'Skrap7:an Presentkod';
    case 8:
      return 'MiniTriss Presentkod';
    case 9:
      return 'Skrap PAC-MAN Presentkod';
    case 10:
      return 'SkrapMatcha Presentkod';
    case 11:
      return 'SkrapKeno Presentkod';
    case 12:
      return 'SkrapKryss Presentkod';
    case 13:
      return 'SkrapBingo Presentkod';
    case 14:
      return 'BilTriss Presentkod';
    case 15:
      return 'Triss Adventskalender Presentkod';
    default:
      return 'Okänd produktkod';
  }
};

const isLoggedIn = () => svs.core.userSession.hasRole(svs.core.userSession.roles.RETAILER_CORP);
const isOnlyDigits = (value) => /^\d+$/.test(value);
const ONLY_DIGITS = 'Fältet får bara innehålla siffror.';
const zipCodeErrors = {
  ONLY_DIGITS: 'Fältet får bara innehålla siffror.',
  MAX: 'Fältet får inte innehålla mer än 5 siffror',
  MIN: 'Fältet får inte innehålla färre än 5 siffror'
};

const validateZipCode = (value) => {
  const { ONLY_DIGITS, MAX, MIN } = zipCodeErrors;
  const trimmedValue = value.trim().replaceAll(' ', '');
  if (!isOnlyDigits(trimmedValue)) {
    return { errorMessage: ONLY_DIGITS, isValid: false };
  }

  if (trimmedValue.length !== 5) {
    const message = trimmedValue.length > 5 ? MAX : MIN;
    return { errorMessage: message, isValid: false };
  }
  return { errorMessage: '', isValid: true };
};
const validateIsOnlyDigits = (value) => {
  const trimmedValue = value.trim().replaceAll(' ', '');
  if (!isOnlyDigits(trimmedValue)) {
    return { errorMessage: ONLY_DIGITS, isValid: false };
  }
  return { errorMessage: '', isValid: true };
};

const luhn = (str) => {
  let sum = 0;

  str = String(str);

  for (let i = 0, l = str.length; i < l; i++) {
    let v = parseInt(str[i], 10);
    v *= 2 - (i % 2);
    if (v > 9) {
      v -= 9;
    }
    sum += v;
  }

  return sum % 10 === 0;
};

const orgNumberRegex = () => /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([-+]?)?(\d{3})(\d)$/g;
const INVALID_ORGNUMBER = 'Ej giltig organisationsnummer';
const validateOrgNumber = (org) => {
  if (org.length < 10 || org.length > 13) {
    return { errorMessage: INVALID_ORGNUMBER, isValid: false };
  }

  try {
    const match = orgNumberRegex().exec(org);
    if (!match) {
      return { errorMessage: INVALID_ORGNUMBER, isValid: false };
    }

    let number = org.replace('-', '');

    if (match[1]) {
      if (Number(match[1]) !== 16) {
        throw new Error(INVALID_ORGNUMBER);
      }
      number = number.slice(2);
    }

    if (Number(match[3]) < 20) {
      throw new Error(INVALID_ORGNUMBER);
    }

    if (Number(match[2]) < 10) {
      return { errorMessage: INVALID_ORGNUMBER, isValid: false };
    }

    if (!luhn(number)) {
      return { errorMessage: INVALID_ORGNUMBER, isValid: false };
    }
    return { errorMessage: '', isValid: true };
  } catch (err) {
    if (!svs.components.formValidation.validateSsn10or12(org.replace('-', ''))) {
      return { errorMessage: INVALID_ORGNUMBER, isValid: false };
    }
    return { errorMessage: '', isValid: true };
  }
};

const formatOrgNumber = (number, separator = true) => {
  try {
    if (!validateOrgNumber(number.replace('-', '')).isValid) {
      return number;
    }
    if (svs.components.formValidation.validateSsn10or12(number)) {
      if (number.length === 12) {
        number = number.slice(2, 12);
      }
    } else {
      const match = orgNumberRegex().exec(number);
      if (match[1]) {
        number = number.slice(2);
      }
    }
    if (number.includes('-')) {
      separator = false;
    }
    return separator ? number.slice(0, 6) + '-' + number.slice(6) : number;
  } catch (e) {
    return number;
  }
};

svs.ticket_partner.utils = {
  loginErrorMapper,
  showErrorDialog,
  isLoggedIn,
  productMapper,
  showSuccessDialog,
  showTermsDialog,
  login,
  validateZipCode,
  zipCodeErrors,
  showSummaryDialog,
  validateIsOnlyDigits,
  validateOrgNumber,
  formatOrgNumber,
  INVALID_ORGNUMBER
};


 })(window);